export default {
  "header.language": "Language",
  "Log in": "Log In",
  "Sign Up": "Sign Up",
  "Buy Crypto": "Buy Crypto",
  "header.quicktrade": "Buy Crypto",
  "header.quicktrade.desc":
    "Quickly buy and sell virtual assets using a bank card",
  "header.C2C": "P2P Trading",
  "header.C2C.desc":
    "Simple operations, Quick transactions, Start your first trade",
  "header.u.account": "Account Management",
  "header.u.fee": "My Fee Rate",
  "header.u.bonus": "My Bonuses",
  "header.u.c2c": "P2P Settings",
  "header.u.invite": "Invite Friends",
  "header.u.api": "API Management",
  "header.u.logout": "Logout",
  "header.rate": "Exchange Rate",
  Market: "Markets",
  Spot: "Spot",
  Futures: "Futures",
  koltrade: "Copy Trading",
  Bonus: "Bonus",
  Agent: "Affiliates",
  more: "View More",
  "Perpetual Contract": "Perpetual Contract",
  "header.assets": "Assets",
  "header.order": "Orders",
  totalAssets: "Total Assets Overview",
  exchangeAccount: "Spot Account",
  otcAccount: "P2P Account",
  coAccount: "Futures Account",
  exchangeOrder: "Spot Orders",
  otcOrder: "P2P Orders",
  coOrder: "Futures Orders",
  "header.appDownLoad": "Scan to Download APP",
  "header.moreload": "More Download Options",
  "index.banner.2": "The AI - Driven Exchange that knows you best",
  "Register Now": "Register Now",
  "Trade Now": "Trade Now",
  "index.register.type": "Email/Phone Number",
  "index.banner.desc": "Register to receive up to {amount} in task rewards",

  "index.text1": "Excellent",
  "index.text2": "Spot Liquidity",
  "index.text3": "Futures Liquidity",
  "index.text4": "Spread",
  "index.text5": "Liquidity",
  "index.text6": "Ranking",
  "index.c4.title": "Professional and User-Friendly",
  "index.c4.title2":
    "VOOX provides a cryptocurrency platform for traders of all levels",
  "index.c4.t1.t": "Spot Trading",
  "index.c4.t1.p":
    "Trade major cryptocurrencies like BTC, ETH, and USDT with deep liquidity and fast execution",
  "index.c4.t2.t": "Futures Trading",
  "index.c4.t2.p":
    "Enhance your trading potential with flexible leveraged futures trading",
  "index.c4.t3.t": "Copy Trading",
  "index.c4.t3.p":
    "Follow top traders, track market trends, and easily optimize your strategy",
  "index.c5.title": "Earn Easily with VOOX",
  "index.c5.title2":
    "Unlock the power of crypto trading on VOOX's intuitive platform",
  "index.c5.t1.t": "Experience Zero-Cost Futures Trading with VOOX",
  "index.c5.t1.p":
    "Take advantage of our generous bonus promotions to quickly master futures trading and earn profits with ease",
  "index.c5.t2.t": "Profit Smartly with Top Traders",
  "index.c5.t2.p":
    "Our advanced copy trading platform connects you with the best traders. Simply delegate and enjoy the returns",
  "index.c6.title": "Unparalleled Security",
  "index.c6.title2": "VOOX protects your assets 24/7",
  "index.c6.1.t": "Comprehensive Audits",
  "index.c6.1.p":
    "VOOX conducts thorough audits to ensure the integrity and security of our platform, making every transaction transparent and reliable",
  "index.c6.2.t": "Secure Custody Partnerships",
  "index.c6.2.p":
    "VOOX partners with top-tier crypto custodians to enhance the security of your assets. Our partnerships are based on a commitment to the highest security standards",
  "index.c6.3.t": "Cold Storage Security",
  "index.c6.3.p":
    "VOOX uses secure cold storage solutions to protect your digital assets, minimizing risk and ensuring your funds are safe from unauthorized access",
  "index.c6.4.t": "Legal and Compliant",
  "index.c6.4.p":
    "VOOX strictly adheres to legal and regulatory standards, providing a secure trading environment for our users",
  "c7.title": "Seamless Trading Experience",
  "c7.title2":
    "Access global crypto markets anytime, anywhere through VOOX's mobile and web platforms",
  c7_qrcode: "Scan to Download the App",
  c7_qrcode1: "Download the VOOX App for Android/iOS",
  "c8.title": "Start Your Crypto Journey",
  "c8.title2": "VOOX's AI-driven insights help you trade smarter and earn more",
  "footer.contractus": "Contact Us",
  "footer.media": "Social Media",
  "footer.downloadapp": "Download App",
  "footer.product": "Products",
  "footer.creditCardPurchase": "Buy Crypto",
  "footer.c2c": "P2P",
  "footer.trade": "Spot Trading",
  "footer.futures": "Futures Trading",
  "footer.futures": "Futures Trading",
  "footer.koltrade": "Copy trading",
  "footer.bonus": "Bonus",
  "footer.business": "Business",
  "footer.cms.apply": "Listing Application",
  "footer.agent.apply": "Agent Application",
  "footer.c2c.apply": "P2P Merchant Application",
  "footer.support": "Support",
  "footer.mesage": "Announcements",
  "footer.help": "Help Centre",
  "footer.fee": "Fees",
  "footer.about": "About Us",
  "footer.agreement": "Terms",
  "footer.privacy": "Privacy",
  "footer.disclaimer": "AML Policy",
  "footer.companyname": "Company Name: VOOX Limited",
  "footer.companynumber": "Company Registration Number: 20241849145",
  "footer.companyaddress":
    "Company Address: 1312 17th Street, Unit Num 2955, Denver, CO 80202, United States",
  "footer.customerService": "Customer Service Center",
  "footer.online_custom": "Customer Service Center",
  "footer.requests": "Submit a request",
  Notice: "Notice",
  "notFound.title": "404 | VOOX",
  "notFound.desc":
    "Sorry, the page you are trying to access does not exist.",
  "notFound.backHome": "Return to the homepage.",
};
